<div class="login-container">
  @if (isBannerLogoVisible) {
    <div class="company-logo">
      @if ((applicationInfo$ | async)?.ApplicationDetails?.ApplicationLogoType !== "SVG_LOGO") {
        @if ((applicationInfo$ | async)?.ApplicationDetails?.ApplicationLogoUrl) {
          <img height="50" [src]="(applicationInfo$ | async)?.ApplicationDetails?.ApplicationLogoUrl" alt="Logo" />
        }
      }
      @if ((applicationInfo$ | async)?.ApplicationDetails?.ApplicationLogoType === "SVG_LOGO") {
        <div class="svg-image" [innerHTML]="(applicationInfo$ | async)?.ApplicationDetails?.ApplicationLogoUrl | sanitizer: 'html'"></div>
      }
    </div>
  }
  <div class="login-card">
    @if (isCardLogoVisible) {
      <div class="login-card--logo pb-2">
        @if ((applicationInfo$ | async)?.ApplicationDetails?.ApplicationLogoType !== "SVG_LOGO") {
          @if ((applicationInfo$ | async)?.ApplicationDetails?.ApplicationLogoUrl) {
            <img height="50" [src]="(applicationInfo$ | async)?.ApplicationDetails?.ApplicationLogoUrl" alt="Logo" />
          }
        }
        @if ((applicationInfo$ | async)?.ApplicationDetails?.ApplicationLogoType === "SVG_LOGO") {
          <div class="svg-image" [innerHTML]="(applicationInfo$ | async)?.ApplicationDetails?.ApplicationLogoUrl | sanitizer: 'html'"></div>
        }
      </div>
    }
    <div class="position-relative d-flex justify-content-center align-items-center">
      @if (selectedActionType !== ACTION_TYPE.LOGIN) {
        <div class="p-1 bg-primary border-radius-5 d-flex justify-content-center align-items-center arrow-back-action" matRipple>
          <mat-icon class="text-white" (click)="onLoginPage()">arrow_back</mat-icon>
        </div>
      }
      <h1 class="login-card--heading">
        {{ getCardTitle }}
      </h1>
    </div>
    <div class="login-card--body">
      @if (selectedActionType === ACTION_TYPE.LOGIN) {
        <div class="row m-0 p-0">
          <div class="col-12">
            <mobi-office-lib-input-field
              label="Username"
              [(model)]="UserName"
              placeholder="Enter Username"
              [disabled]="false"
              [isRequired]="true"
              type="text"
              (enterEmitter)="onSignIn()"></mobi-office-lib-input-field>
          </div>
          <div class="col-12 mt-2">
            <mobi-office-lib-input-field
              label="Password"
              [(model)]="Password"
              placeholder="Enter Password"
              (enterEmitter)="onSignIn()"
              [disabled]="false"
              [isRequired]="true"
              type="password"></mobi-office-lib-input-field>
          </div>
          @if (isForgetPassword) {
            <div class="col-12 d-flex justify-content-end mt-2">
              <span class="fs-16 text-decoration-underline cursor-pointer forget-password" (click)="forgotPassword()">Forgot Password</span>
            </div>
          }
          <div class="col-12" [ngClass]="{ 'mt-2': isForgetPassword, 'mt-3': !isForgetPassword }">
            <button class="btn-xl-filled-primary w-100" (click)="onSignIn()" matRipple>Sign In</button>
          </div>
        </div>
      } @else if (selectedActionType === ACTION_TYPE.FORGOT_PASSWORD) {
        <div class="row m-0 p-0">
          <div class="col-12">
            <mobi-office-lib-input-field label="Email ID" [(model)]="emailID" placeholder="Enter Email ID" [disabled]="false" [isRequired]="true" type="email"></mobi-office-lib-input-field>
          </div>
          <div class="col-12 mt-3">
            <button class="btn-xl-filled-primary w-100" matRipple (click)="onContinue()">Continue</button>
          </div>
        </div>
      } @else if (selectedActionType === ACTION_TYPE.VERIFY_OTP) {
        <div class="row m-0 p-0">
          <div class="col-12">
            <span class="otp-sent-timer-copy fs-14"
              >OTP sent on email : <span class="fw-bold">{{ emailID }}</span></span
            >
          </div>
          <div class="col-12 mt-2">
            <mobi-office-lib-input-box [size]="6" [(ngModel)]="OTP"></mobi-office-lib-input-box>
          </div>
          <div class="col-12 mt-2">
            <p class="otp-resend-copy fs-14 m-0 text-center">
              You didn't received OTP ?
              @if (timeInterval <= 0) {
                <span (click)="sentOTP()" class="cursor-pointer resend-copy"> Resend </span>
              } @else {
                <span class="timer-copy">{{ timeInterval + " seconds" }}</span>
              }
            </p>
          </div>
          <div class="col-12 mt-3">
            <button class="btn-xl-filled-primary w-100" matRipple (click)="onVerifyOtp()">Verify OTP</button>
          </div>
        </div>
      } @else if (selectedActionType === ACTION_TYPE.RESET_PASSWORD) {
        <div class="row m-0 p-0">
          <div class="col-12">
            <mobi-office-lib-input-field label="Password" [(model)]="password" placeholder="Enter Password" [disabled]="false" [isRequired]="true" type="password"></mobi-office-lib-input-field>
          </div>
          <div class="col-12 mt-2">
            <mobi-office-lib-input-field
              label="Confirm Password"
              [(model)]="confirmPassword"
              placeholder="Enter Confirm Password"
              [disabled]="false"
              [isRequired]="true"
              type="password"></mobi-office-lib-input-field>
          </div>
          <div class="col-12 mt-3">
            <button class="btn-xl-filled-primary w-100" matRipple (click)="onResetPassword()">Reset Password</button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
